module.exports = __webpack_public_path__ + "sj.svg?063d1a48a4d4125072549919ad57e6da";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sj.svg
// module id = 1376
// module chunks = 27